module.exports = __webpack_public_path__ + "img/pro_ten_3.bc8a5066.jpg";